export default function CConstants() {
  return <h2>C Constants</h2>;
}
